export default __webpack_public_path__ + "static/media/citySpark-price-5000-will-jamous-LongArrow.e8a2b9f7.webp";